<template>
  <modal :withOkBtn="true" :withCancelBtn="false" @ok="$emit('ok')">
    <div slot="header">About</div>
    <div slot="body">
      <p class="about-paragraph">
        Orchestra Storyteller is a free tool for creating rich interactive
        cultural and educational experiences.
        <br />Once you create one, you may install it in Orchestra Appliance and
        watch it work in your space, or you can publish it in Orchestra Gallery
        and start making money out of it!
      </p>
      <p>
        <a
          href="https://www.orchestra-suite.com"
          target="_blank"
          class="learn-more"
          >Learn more...</a
        >
      </p>
      <p>Version {{ version }}</p>
    </div>
  </modal>
</template>

<script>
import Modal from "./Modal";

export default {
  name: "home",
  components: {
    modal: Modal,
  },
  data() {
    return {
      version: "",
    };
  },
  mounted() {
    this.version = JSON.parse(localStorage.getItem("version"));
  },
};
</script>

<style scoped>
.about-paragraph {
  padding: 0 5%;
}

.learn-more {
  color: #5cc1a6;
}
</style>